module.exports = __webpack_public_path__ + "img/edit.91ff1529.svg";